<template>
  <div class="login">
    <EpButton
      :kind="'primary'"
      :element="'a'"
      :link="redirect_uri"
      :label="true"
      :labelText="'Connect to Strava'"
      :icon="true"
      :iconSource="'sign-in'"
      :iconAlignRight="true"
    />
  </div>
</template>

<script>
  import EpButton from '@ericpitcock/ep-design-system/src/components/EpButton.vue'
  
  export default {
    name: 'Login',
    components: {
      EpButton
    },
    computed: {
      redirect_uri() {
        return `https://www.strava.com/oauth/authorize?client_id=50822&redirect_uri=${process.env.VUE_APP_REDIRECT_DOMAIN}/authorize&response_type=code&scope=activity:read_all`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
